import { useSelector } from "react-redux";

function Profile() {
  const user = useSelector((state) => state.auth.user);

  return (
    <div className="container">
      <h2>Profile</h2>
      {user ? (
        <div>
          <p>Name: {user.name}</p>
          <p>Email: {user.email}</p>
        </div>
      ) : (
        <p>No user logged in</p>
      )}
    </div>
  );
}

export default Profile;